import MaintenancePage from "../../components/feature/MaintenancePage";
import SEOHead from "../../components/feature/SEOHead";

const LOGO =
  "https://storage.readdy-site.link/project_files/9ee712e0-c50a-4d2b-9956-d4b4346de3f4/7b4d52ff-db18-4dfe-b6b1-ff3b6d5401f0_Splinkos_Logo.png?v=5cb6dc88138261524908c8ba0641eeee";

const siteUrl = (import.meta.env.VITE_SITE_URL as string) || "https://example.com";

const schema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${siteUrl}/splinkos#website`,
  name: "Splinkos",
  url: `${siteUrl}/splinkos`,
  inLanguage: "en-AU",
  description:
    "Splinkos is currently undergoing scheduled maintenance. We'll be back soon with an improved online gaming experience for all users.",
  potentialAction: {
    "@type": "SearchAction",
    target: `${siteUrl}/splinkos?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

export default function Splinkos() {
  return (
    <>
      <SEOHead
        title="Splinkos | We'll Be Back Shortly — Maintenance Mode"
        description="Splinkos is currently undergoing scheduled maintenance. We'll be back soon with an improved experience for all users."
        keywords="Splinkos, online gaming, maintenance, coming soon"
        canonicalPath="/splinkos"
        schemaJson={schema}
        ogImage={LOGO}
        ogImageAlt="Splinkos Logo"
        siteName="Splinkos"
      />
      <MaintenancePage
        logoSrc={LOGO}
        logoAlt="Splinkos Logo"
        accentColor="#00E5FF"
        glowRgb="0,229,255"
        bgFrom="#001A20"
        whatsappLink="https://wa.me/61451474341"
        telegramLink="https://t.me/SPLINKOSAUCS001"
      />
    </>
  );
}
